// App.js
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Outlet,
  Navigate,
} from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import LoginPage from "./pages/LoginPage";
import "./styles/bottomtab.css";
import RegistrationPage from "./pages/RegistrationPage";
import RPMList from "./pages/RPMList";
import PatientDashboard from "./pages/PatientDashboard";
import { Toaster } from "react-hot-toast";
import ChatInterface from "./pages/ChatInterface";
import PatientSearch from "./pages/PatientSearch";
import Cardiology from "./pages/MedicalCategories/Cardiology";

const queryClient = new QueryClient();

const PrivateRoute = () => {
  return localStorage.getItem("user_info") !== null ? (
    <div className="w-100 mainBglight">
      <Toaster />
      <Outlet />
    </div>
  ) : (
    <Navigate to="/" />
  );
};

const PublicRoute = () => {
  return (
    <div className="bg-[#3F4A9C] h-100">
      <div
        className="w-100"
      >
        <Outlet />
      </div>
    </div>
  );
};
const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <Routes>
          <Route element={<PrivateRoute />}>
            <Route path="/landing/patient-search" element={<PatientSearch />} />
            <Route path="/landing/medical-categories/cardiology" element={<Cardiology />} />
            <Route path={`/landing/rpm_list`} element={<RPMList />} />
            <Route
              path={`/landing/rpm_list/:id`}
              element={<PatientDashboard />}
            />
          </Route>

          <Route element={<PublicRoute />}>
            <Route exact path="/" element={<LoginPage />} />
            <Route exact path="/registration" element={<RegistrationPage />} />
            <Route path="/chat" element={<ChatInterface />} />
          </Route>
        </Routes>
      </Router>
    </QueryClientProvider>
  );
};

export default App;
